import { useEffect, useRef, useCallback } from 'react';

/**
 * Calls onLoadMore when the sentinel element intersects the viewport (scroll-based loading).
 */
export function useScrollLoadTrigger({ onLoadMore, hasMore, isLoading, rootMargin = '0px 0px 100px 0px', disabled = false }) {
  const sentinelRef = useRef(null);
  const onLoadMoreRef = useRef(onLoadMore);
  onLoadMoreRef.current = onLoadMore;

  const stableLoad = useCallback(() => {
    onLoadMoreRef.current?.();
  }, []);

  useEffect(() => {
    if (disabled || !hasMore || isLoading) return;
    const el = sentinelRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;

    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) stableLoad();
      },
      { root: null, rootMargin, threshold: 0 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [disabled, hasMore, isLoading, rootMargin, stableLoad]);

  return sentinelRef;
}
